import script from "./ManualPresence.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualPresence.vue?vue&type=script&setup=true&lang=js"

import "./ManualPresence.vue?vue&type=style&index=0&id=16b5eb7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b5eb7a"]])

export default __exports__